<template>
  <div
    class="row match-height"
    v-bind:class="{ fullscreen_expand: isFullscreen }"
  >
    <div class="col-xl-12 col-lg-12">
      <div class="card" style="">
        <div class="card-header">
          <a class="heading-elements-toggle"
            ><i
              class="fa fa-ellipsis-v font-medium-3"
              @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
            ></i
          ></a>
          <div
            class="heading-elements"
            v-bind:class="{
              visible: getSubMenuShowHideFw(),
              '': !getSubMenuShowHideFw(),
            }"
          >
            <ul class="list-inline mb-0">
              <li>
                <a @click="onFilterReset()" v-b-tooltip title="Atualizar"
                  ><i class="ft-rotate-cw"></i
                ></a>
              </li>
              <li>
                <a
                  @click="expandFullscreen()"
                  v-b-tooltip
                  title="Expande a tela"
                  v-if="!isFullscreen"
                  ><i class="ft-maximize"></i
                ></a>
              </li>
              <li>
                <a
                  @click="expandFullscreen()"
                  v-b-tooltip
                  title="Minimiza a tela"
                  v-if="isFullscreen"
                  ><i class="ft-minimize"></i
                ></a>
              </li>
            </ul>
          </div>
        </div>
        <div class="card-content">
          <!-- <div class="table-responsive col-md-12"> -->
          <!-- <div class="row">
              <div class="col-md-6 pt-1">
                <div class="row">
                  <div class="col-md-12 pt-1">
                    <h4 class="card-title">Integração BFiscal</h4>
                    <br />
                    <toggle-button
                      @change="onChangeStatusBFiscal"
                      :value="this.form.status_integracao_bfiscal"
                      :sync="true"
                      :width="100"
                      :height="28"
                      :labels="{ checked: 'Ativado', unchecked: 'Inativado' }"
                    />
                  </div>
                  <div
                    class="col-md-12"
                    v-if="this.form.status_integracao_bfiscal == 1"
                  >
                    <div class="col-md-12">
                      <multiselect
                        v-model="form.tp_auth_code"
                        :options="this.$parent.optionsLivTpAuthCode"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Selecione"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                      ></multiselect>
                      <b-form-feedback
                        class="text-danger"
                        v-text="
                          form.errors.get('tp_auth_code.value')
                        "
                        v-if="form.errors.has('tp_auth_code.value')"
                      ></b-form-feedback>
                    </div>
                    <div class="col-md-12">
                      <label class="form-label">Chave</label>
                    </div>
                    <div class="col-md-12">
                      <textarea
                        rows="8"
                        v-model="form.auth_code"
                        class="form-control"
                      >
                      </textarea>
                    </div>
                    <button
                      type="button"
                      class="btn btn-inline"
                      @click="doTestarConexao()"
                      v-if="getPermission('conta.apikey')"
                    >
                      Testar Conexão
                    </button>
                  </div>

                  <div
                    class="col-md-12 pt-1"
                    v-if="form.tp_integracao_cte.value == 5"
                  >
                    <div class="col-md-12">
                      <label class="form-label">URL Endpoint Integração</label>
                      <b-form-input
                        type="text"
                        placeholder="URL Endpoint"
                        v-model="form_api_externa.api_externa_url_endpoint"
                      >
                      </b-form-input>
                      <b-form-feedback
                        class="text-danger"
                        v-text="
                          form_api_externa.errors.get(
                            'api_externa_url_endpoint'
                          )
                        "
                        v-if="
                          form_api_externa.errors.has(
                            'api_externa_url_endpoint'
                          )
                        "
                      ></b-form-feedback>
                    </div>

                    <div class="col-md-12">
                      <label class="form-label">Selecionar método</label>
                      <multiselect
                        v-model="form_api_externa.api_externa_tp_auth"
                        :options="this.$parent.optionsLivApiExternaTpAuth"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Selecione"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                      ></multiselect>
                      <b-form-feedback
                        class="text-danger"
                        v-text="
                          form_api_externa.errors.get(
                            'api_externa_tp_auth.value'
                          )
                        "
                        v-if="
                          form_api_externa.errors.has(
                            'api_externa_tp_auth.value'
                          )
                        "
                      ></b-form-feedback>
                    </div>

                    <div class="col-md-6">
                      <b-form-text
                        >Usuário
                        <span
                          v-b-tooltip
                          title="Usuário de conexão API"
                          placement="top"
                          >[?]</span
                        ></b-form-text
                      >
                      <input
                        type="text"
                        v-model="form_api_externa.api_externa_usuario"
                        class="form-control input-sm"
                      />
                      <b-form-feedback
                        class="text-danger"
                        v-text="
                          form_api_externa.errors.get('api_externa_usuario')
                        "
                        v-if="
                          form_api_externa.errors.has('api_externa_usuario')
                        "
                      ></b-form-feedback>
                    </div>

                    <div class="col-md-6">
                      <b-form-text
                        >Senha
                        <span
                          v-b-tooltip
                          title="Senha de conexão API. Caso preenchida é atualizada. Caso em branco permanece a pré cadastrada"
                          placement="top"
                          >[?]</span
                        ></b-form-text
                      >
                      <input
                        type="password"
                        v-model="form_api_externa.api_externa_senha"
                        class="form-control input-sm"
                      />
                      <b-form-feedback
                        class="text-danger"
                        v-text="
                          form_api_externa.errors.get('api_externa_senha')
                        "
                        v-if="form_api_externa.errors.has('api_externa_senha')"
                      ></b-form-feedback>
                    </div>

                    <div class="col-md-6">
                      <b-form-text
                        >URL Externa Cliente<span
                          v-b-tooltip
                          title="URL"
                          placement="top"
                          >[?]</span
                        ></b-form-text
                      >
                      <input
                        type="text"
                        v-model="form_api_externa.api_externa_url_cliente"
                        class="form-control input-sm"
                      />
                      <b-form-feedback
                        class="text-danger"
                        v-text="
                          form_api_externa.errors.get('api_externa_url_cliente')
                        "
                        v-if="
                          form_api_externa.errors.has('api_externa_url_cliente')
                        "
                      ></b-form-feedback>
                    </div>

                    <div class="col-md-6">
                      <b-form-text
                        >Usuário
                        <span v-b-tooltip title="Usuário URL" placement="top"
                          >[?]</span
                        ></b-form-text
                      >
                      <input
                        type="text"
                        v-model="form_api_externa.usuario_inc"
                        class="form-control input-sm"
                      />
                      <b-form-feedback
                        class="text-danger"
                        v-text="form_api_externa.errors.get('usuario_inc')"
                        v-if="form_api_externa.errors.has('usuario_inc')"
                      ></b-form-feedback>
                    </div>

                    <div class="col-md-12">
                      <label class="form-label">Chave autenticação</label>
                    </div>
                    <div class="col-md-12">
                      <textarea
                        rows="8"
                        v-model="form_api_externa.api_externa_auth_code"
                        class="form-control"
                      >
                      </textarea>
                      <b-form-feedback
                        class="text-danger"
                        v-text="
                          form_api_externa.errors.get('api_externa_auth_code')
                        "
                        v-if="
                          form_api_externa.errors.has('api_externa_auth_code')
                        "
                      ></b-form-feedback>
                    </div>

                    <div class="col-md-6">
                      <button
                        type="button"
                        class="btn btn-inline"
                        @click="doTestarConexaoApiExterna()"
                        v-if="getPermission('conta.apikey')"
                      >
                        Testar Conexão
                      </button>
                    </div>
                  </div>
                </div>
              </div> -->
          <b-row div class="col-md-12 mb-1">
            <b-col>
              <h5 class="card-title">Integração SEFAZ</h5>
              <multiselect
                v-model="tpIntegracaoSefazSelected"
                :options="this.$parent.optionsLivTpIntegracaoSefaz"
                track-by="value"
                label="label"
                :hide-selected="true"
                placeholder="Selecione"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
              ></multiselect>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('tp_integracao_sefaz.value')"
                v-if="form.errors.has('tp_integracao_sefaz.value')"
              ></b-form-feedback>
            </b-col>
            <b-col>
              <h4 class="card-title">Integração de Fatura</h4>
              <multiselect
                v-model="tpIntegracaoFaturaSelected"
                :options="this.$parent.optionsLivTpIntegracaoFatura"
                track-by="value"
                label="label"
                :hide-selected="true"
                placeholder="Selecione"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
              ></multiselect>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('tp_integracao_fatura.value')"
                v-if="form.errors.has('tp_integracao_fatura.value')"
              ></b-form-feedback>
            </b-col>
            <b-col>
              <h4 class="card-title">Integração de Clientes</h4>
              <multiselect
                v-model="tpIntegracaoClienteSelected"
                :options="this.$parent.optionsLivTpIntegracaoCliente"
                track-by="value"
                label="label"
                :hide-selected="true"
                placeholder="Selecione"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
              ></multiselect>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('tp_integracao_cliente.value')"
                v-if="form.errors.has('tp_integracao_cliente.value')"
              ></b-form-feedback>
            </b-col>

            <b-col>
              <h4 class="card-title">Integração de CTE</h4>
              <multiselect
                v-model="tpIntegracaoCteSelected"
                :options="this.$parent.optionsLivTpIntegracaoCte"
                track-by="value"
                label="label"
                :hide-selected="true"
                placeholder="Selecione"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
              ></multiselect>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('tp_integracao_cte.value')"
                v-if="form.errors.has('tp_integracao_cte.value')"
              ></b-form-feedback>
            </b-col>
          </b-row>

          <b-row class="col-md-12 col-sm-12">
            <b-col>
              <label>Access key: </label>
              <b-form-input
                type="text"
                placeholder="Access key s3"
                v-model="form.access_key_s3"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('access_key_s3')"
                v-if="form.errors.has('access_key_s3')"
              ></b-form-feedback>
            </b-col>

            <b-col>
              <label>Secret key: </label>
              <b-form-input
                type="password"
                placeholder="Secret Key S3"
                v-model="form.secret_key_s3"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('secret_key_s3')"
                v-if="form.errors.has('secret_key_s3')"
              ></b-form-feedback>
            </b-col>

            <b-col>
              <label>Bucket S3: </label>
              <b-form-input
                type="text"
                placeholder="Bucket S3"
                v-model="form.bucket_s3"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('bucket_s3')"
                v-if="form.errors.has('bucket_s3')"
              ></b-form-feedback>
            </b-col>

            <b-col>
              <label>Pasta S3: </label>
              <b-form-input
                type="text"
                placeholder="Pasta S3"
                v-model="form.pasta_s3"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('pasta_s3')"
                v-if="form.errors.has('pasta_s3')"
              ></b-form-feedback>
            </b-col>
          </b-row>
          <b-row div class="col-md-12 mt-2">
            <b-col>
              <h5 class="card-title">Integração Gestão de pagamento</h5>
            </b-col>
          </b-row>
          <b-row div class="col-md-12 mb-1">
            <b-col>
              <label>Quantidade de horas cancelamento Ciot: </label>
              <b-form-input
                type="number"
                placeholder="Quantidade de horas cancelamento Ciot"
                v-model="form.qtd_horas_ciot"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('bucket_s3')"
                v-if="form.errors.has('bucket_s3')"
              ></b-form-feedback>
            </b-col>
            <b-col>
              <label>Quantidade de horas cancelamento Vale Pedágio: </label>
              <b-form-input
                type="number"
                placeholder="Quantidade de horas cancelamento Vale Pedágio"
                v-model="form.qtd_horas_pedagio"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('bucket_s3')"
                v-if="form.errors.has('bucket_s3')"
              ></b-form-feedback>
            </b-col>
            <div class="col-md-12 mt-1">
              <div
                class="float-right"
                v-if="getPermission('conta.update.integracao')"
              >
                <b-btn @click="onUpdateIntegracao()" variant="secondary">
                  Salvar configurações
                </b-btn>
              </div>
            </div>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueClipboard from "vue-clipboard2";
import ToggleButton from "vue-js-toggle-button";

Vue.use(VueClipboard);
Vue.use(ToggleButton);

export default {
  data() {
    return {
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      teste: "",
      isFullscreen: false,
      loading: false,
      disabled: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      showModalPermission: false,
      optionsLivTpIntegracaoFatura: [],
      optionsLivTpIntegracaoCte: [],
      optionsLivTpIntegracaoSefaz: [],
      optionsLivTpAuthCode: [],
      optionsLivTpIntegracaoCliente: [],
      optionsParamTpEmail: [],
      optionsLivApiExternaTpAuth: [],
      tpIntegracaoSefazSelected: [],
      tpIntegracaoFaturaSelected: [],
      tpIntegracaoClienteSelected: [],
      tpIntegracaoCteSelected: [],
      form: new Form({
        api_key: "",
        status_integracao_bfiscal: "",
        tp_integracao_fatura: "",
        tp_integracao_cte: "",
        tp_integracao_cliente: "",
        tp_integracao_sefaz: "",
        tp_auth_code: [],
        access_key_s3: "",
        secret_key_s3: "",
        bucket_s3: "",
        auth_code: "",
        pasta_s3: "",
        qtd_horas_ciot: "",
        qtd_horas_pedagio: "",
      }),
      form_api_externa: new Form({
        api_externa_url_endpoint: "",
        api_externa_usuario: "",
        api_externa_senha: "",
        api_externa_tp_auth: [],
        api_externa_auth_code: "",
        api_externa_url_cliente: "",
        usuario_inc: "",
      }),
      helpForm: new Form({
        statusRecord: [],
        senhadicionario: [],
        params: [],
        search: "",
      }),
      moreParams: {},
    };
  },
  watch: {
    tpIntegracaoSefazSelected(obj) {
      this.form.tp_integracao_sefaz = obj.value;
    },
    tpIntegracaoFaturaSelected(obj) {
      this.form.tp_integracao_fatura = obj.value;
    },
    tpIntegracaoClienteSelected(obj) {
      this.form.tp_integracao_cliente = obj.value;
    },
    tpIntegracaoCteSelected(obj) {
      this.form.tp_integracao_cte = obj.value;
    },
  },
  mounted() {
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
    this.$events.$on("reloadResponse", (response) =>
      this.onReloadResponse(response)
    );
  },
  created() {
    let self = this;
    Event.$on("reloadVuetable", function (data) {
      self.onReloadVuetable();
    });
  },
  methods: {
    expandFullscreen() {
      this.isFullscreen = !this.isFullscreen;
    },
    doGerarChave(e) {
      this.form
        .post("/api/conta/gerarapikey/")
        .then((response) => {
          this.integracaoData();
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    doTestarConexao(e) {
      this.form
        .post("/api/conta/api/testar")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    doTestarConexaoApiExterna(e) {
      this.form
        .post("/api/conta/api_externa/testar")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    integracaoData() {
      this.loadingData = true;
      this.form
        .get("/api/conta/integracao")
        .then((response) => {
          new ReturnApi(response, this);
          this.form.access_key_s3 = response.data.BConfigBlogistic.accessKeyS3;
          this.form.bucket_s3 = response.data.BConfigBlogistic.bucketS3;
          this.form.pasta_s3 = response.data.BConfigBlogistic.pastaS3;
          this.form.qtd_horas_pedagio = response.data.BConfigBlogistic.qtdHorasPedagio;
          this.form.qtd_horas_ciot = response.data.BConfigBlogistic.qtdHorasCiot;
          this.form.pasta_s3 = response.data.BConfigBlogistic.pastaS3;
          this.tpIntegracaoSefazSelected = {
            label: response.data.BConfigBlogistic.tpIntegracaoSefaz.descr,
            value: response.data.BConfigBlogistic.tpIntegracaoSefaz.valor,
          };
          this.tpIntegracaoFaturaSelected = {
            label: response.data.BConfigBlogistic.tpIntegracaoFatura.descr,
            value: response.data.BConfigBlogistic.tpIntegracaoFatura.valor,
          };
          this.tpIntegracaoClienteSelected = {
            label: response.data.BConfigBlogistic.tpIntegracaoCliente.descr,
            value: response.data.BConfigBlogistic.tpIntegracaoCliente.valor,
          };
          this.tpIntegracaoCteSelected = {
            label: response.data.BConfigBlogistic.tpIntegracaoCte.descr,
            value: response.data.BConfigBlogistic.tpIntegracaoCte.valor,
          };
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
      this.loadingData = false;
    },
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.id);
      }
    },
    onReloadVuetable() {
      this.$refs.vuetable.reload();
    },
    onUpdateIntegracao() {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .post("/api/conta/update/integracao")
        .then((response) => {
          new ReturnApi(response, this);
          this.integracaoData();
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    onReloadResponse(response) {
      new ReturnApi(response, this);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
  computed: {
    user: {
      get() {
        return this.$store.state.logged.user;
      },
    },
    b_plano: {
      get() {
        return this.$store.getters.bplano;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
